// extracted by mini-css-extract-plugin
export default {"DeviceItem":"DeviceItem_DeviceItem__SugvJ","release":"DeviceItem_release__Z6Dls","disabled":"DeviceItem_disabled__88cNh"};